"use client";

import { IconTruck } from "@tabler/icons-react";
import { DietCardRow } from "@/features/cart/components/configure-diet/diet-card/diet-card-row";
import { useDietDeliveryLabel } from "@/features/cart/hooks/use-diet-delivery-label";
import { DietDeliveryInfoDialog } from "@/features/diets/components/diet-info-dialog/diet-delivery-info-dialog";
import type { DietCatalog, DietCatalogDetail } from "@/features/diets/types";

/**
 * Diet card row with the next possible delivery day and the delivery cost,
 * opening the delivery & payment dialog.
 */
export const DietCardDeliveryRow = ({
  diet,
}: {
  diet: DietCatalog | DietCatalogDetail;
}) => {
  const { day, label } = useDietDeliveryLabel({ diet });

  return (
    <DietDeliveryInfoDialog
      deliveryDay={day}
      trigger={
        <DietCardRow
          icon={<IconTruck className="size-5" stroke={1.5} />}
          iconClassName="text-brand-green-500"
          label={label}
          labelClassName="text-brand-green-500"
        />
      }
    />
  );
};
